import BaseComponent from '../../../js/base-component';
import { Modal } from '../../../js/modal';
class CareProductsStepEleven extends BaseComponent {
    constructor(element) {
        super(element);

        let signform = this.element.querySelector('form[name="signform"]') || '';

        this.body = document.querySelector('body') || '';
        this.modal = document.querySelector('.u-modal') || '';
        this.agreement = this.element.querySelector('#agreement') || '';
        this.legalnotice = this.element.querySelector('#legalnotice') || '';
        this.legalnoticeModal = this.element.querySelector('#modal-legalnotice') || '';
        this.modalContent = `<h3>${this.legalnoticeModal.dataset.title}</h3><div class="bold">${ this.legalnoticeModal.dataset.headline}</div><div>${this.legalnoticeModal.dataset.content}</div>`;
        this.modalContainer = document.querySelector('#contentModal') || '';
        this.modal = new Modal( this.modalContainer );
        this.nextButton = this.element.querySelector('.is--care') || '';
        this.postal = this.element.querySelector('#postal') || false;
        this.email = this.element.querySelector('#email') || false;

        if ( this.legalnotice ) this.legalnotice.addEventListener('click', this.checkConsent);
        if ( this.postal )  this.postal.addEventListener('click', this.checkEmail);
        if ( this.email )  this.email.addEventListener('input', this.setPostal);

        this.hasEmail = !(!!(this.postal || this.email));

        if ( this.agreement ) {
            this.agreement.addEventListener('click', this.checkConsent);
        }

        if ( this.legalnoticeModal ) {
            this.legalnoticeModal.addEventListener('click', (evt) => {
                evt.preventDefault();

                this.modal.handleModal('content','open', this.modalContent);
            });
        }

        this.checkConsent();
    }

    onInit() {}

    checkConsent = () => {
        let consent = false;
        if ((this.agreement && this.agreement.checked) || this.agreement === '') {
            consent = true;
        }

        if ( ((this.legalnotice.checked && this.hasEmail) || (this.legalnotice.checked && ( this.postal.checked || this.email.validity.valid )) ) && consent ) {
            this.nextButton.removeAttribute('disabled');
        } else {
            this.nextButton.setAttribute('disabled','');
        }
    }

    checkEmail = () => {
        if ( this.postal.checked ) {
            this.email.removeAttribute('required');
            this.email.setAttribute('disabled','');
        } else {
            this.email.setAttribute('required','');
            this.email.removeAttribute('disabled');
        }

        this.checkConsent();
    }

    setPostal = () => {
        if ( this.email.validity.valid ) {
            this.postal.setAttribute('disabled','');
        } else {
            this.postal.removeAttribute('disabled','');
        }

        this.checkConsent();
    }

    setModalContent = (content) => {
        document.querySelector('.u-modal__content').innerHTML = content;
    };
}

export default {
    name: 'CareProductsStepEleven',
    definition: CareProductsStepEleven
};